<template lang="pug">
  div
    span(class="cursor-pointer" @click="changeSpeed(rate)") {{ toGermanString() }} x
</template>

<script>
import { mapState } from 'redux-vuex';
import { setRate } from '@/store/actions/audio';

import store from '@/store';
import select from '@/store/selectors';

const steps = [0.5, 1.0, 1.5, 2.0];

export default {
  data: mapState({
    rate: select.audio.rate,
  }),
  methods: {
    changeSpeed(speedFactor) {
      const activeRateIndex = steps.indexOf(speedFactor);
      const newSpeedRate = steps[(activeRateIndex + 1) % steps.length];
      store.dispatch(setRate(newSpeedRate));
    },
    toGermanString() {
      return this.rate.toLocaleString('de-DE', { minimumFractionDigits: 1 });
    },
  },
};
</script>

<style scoped></style>
